const axios = require("axios");
import host from '@/objetos/host.js'

const { PROTOCOLO, HOST, PORT } = host

const ejecutar_peticion = function({
    body,
    evento
}) {

    return new Promise((resuelve, rechaza) => {
       
        const url =  `${PROTOCOLO}//${HOST}:${PORT}/push/api/${evento}`          
        axios.post(url, body)
            .then((respuesta) => {
                resuelve(respuesta);
            })
            .catch((err) => {
                rechaza(err);
            })
    })
}

export default ejecutar_peticion;
